import { render, staticRenderFns } from "./staff-ranking-filters.vue?vue&type=template&id=3bf07559&"
import script from "./staff-ranking-filters.vue?vue&type=script&lang=js&"
export * from "./staff-ranking-filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports